import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlider = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V7H19V19Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 12H15V13.5H16.5V12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 12H12.5V13.5H14V12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 12H10V13.5H11.5V12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 12H7.5V13.5H9V12Z",
			fill: "currentColor"
		})
	]
});
export default SvgSlider;
